import { Col, Row } from 'antd';
import React, { useEffect } from 'react';
import { ContentInputField } from '../../../../components/atoms/formFields/inputField/contentInputField';
import Select from 'react-select';
import media from '../../../../media';
import TextArea from 'antd/es/input/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { getChildLocationThunk, getParentLocationThunk } from '../../../../store/thunks/locationThunk';
import SelectOption from '../../../../components/atoms/formFields/selectOption';
import { isTenDigitMobile, isValidEmailStrict } from '../../../../utils/regex';
import { ContentTextArea } from '../../../../components/atoms/formFields/textArea';

const GeneralSettings = ({ storeObject, setStoreObject, errors, setErrors, logo }) => {
    console.log("storeObject", storeObject)
    const dispatch = useDispatch();
    const renderInput = (props, colSpan = 8) => (
        <Col className="gutter-row" xs={24} lg={colSpan} key={props.name}>
            <ContentInputField {...props} />
        </Col>
    );

    const sectionHeading = (title) => (
        <Col className="gutter-row" xs={24}>
            <p className="font-weight-bolder font-size-lg mb-3 h5">{title}</p>
        </Col>
    );

    const separator = (
        <Col className="gutter-row" xs={24}>
            <div className="separator separator-solid my-5 d-block"></div>
        </Col>
    );

    const { data } = useSelector((state) => state?.parentLocation?.locations || {});
    const { data: districts } = useSelector(
        (state) => state.childLocations.locations["STATES"] || {}
    );

    const districtOptions = districts?.map((obj) => {
        const { name } = obj
        return ({
            label: name?.en?.toUpperCase(),
            value: obj,
        })
    });

    useEffect(() => {
        dispatch(
            getParentLocationThunk({
                startsWith: "",
                status: "ACTIVE",
                locationType: "STATES",
            })
        );
    }, [dispatch]);

    useEffect(() => {
        dispatch(
            getChildLocationThunk({
                variables: {
                    filterInput: {
                        locationType: "STATES",
                        status: "ACTIVE",
                    },
                    parentIds: [storeObject?.locationRequest?.state?.key],
                },
            })
        );
    }, [storeObject?.locationRequest?.state?.key])


    return (
        <Row gutter={[12, 5]} id="ant_inputs">
            {sectionHeading('General Settings')}

            {renderInput({
                name: 'Store Name',
                required: true,
                errors: errors?.storeName,
                value: storeObject?.storeName?.en,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        storeName: {
                            ...storeObject.storeName,
                            en: e.target.value,
                        },
                    });
                    setErrors({
                        ...errors,
                        storeName: e.target.value
                            ? ""
                            : "Store Name is Mandatory",
                    });
                }
            })}

            {renderInput({
                name: 'Store Email',
                required: true,
                errors: errors?.storeEmail,
                value: storeObject?.storeEmail,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        storeEmail: e.target.value,
                    });
                    setErrors({
                        ...errors,
                        storeEmail: e.target.value
                            ? (isValidEmailStrict(e.target.value)
                                ? ""
                                : "Store Email is Invalid")
                            : "Store Email is Mandatory",
                    });
                }
            })}

            {renderInput({
                name: 'Store Phone Number',
                required: true,
                errors: errors?.mobileNumber,
                value: storeObject?.storePhoneInput?.mobileNumber,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        storePhoneInput: {
                            ...storeObject.storePhoneInput,
                            countryCode: "+91",
                            mobileNumber: e.target.value,
                        },
                    });
                    setErrors({
                        ...errors,
                        mobileNumber: e.target.value
                            ? (isTenDigitMobile(e.target.value) ? "" : "Store Phone Number is Invalid")
                            : "Store Phone Number is Mandatory",
                    });
                }
            })}

            {separator}
            {sectionHeading('Store Brand Setup')}

            <Col className="gutter-row" sm={24} lg={12}>
                <div className="brand-logo">
                    <label className="d-block font-size-lg font-weight-bold mb-6 pl-5">
                        Store Logo <span className='text-danger'>*</span>
                    </label>
                    <div className="align-items-center d-block d-lg-flex max-w-550px">
                        <div className="mb-10 mb-lg-0 mr-lg-10 user_image">
                            <div
                                className={
                                    errors?.logo
                                        ? "image-input image-input-outline invalid"
                                        :
                                        "image-input image-input-outline"
                                }
                                id="kt_image_1"
                            >
                                <div className="image-input-wrapper">
                                    <img
                                        src={
                                            storeObject?.logo
                                                ? URL.createObjectURL(storeObject?.logo)
                                                : logo
                                                    ? logo :
                                                    media.Default
                                        }
                                        alt="img"
                                    />
                                </div>
                                <label
                                    className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="change"
                                    data-toggle="tooltip"
                                    title=""
                                    data-original-title="Change avatar"
                                >
                                    <i className="fa fa-pen icon-sm text-muted"></i>
                                    <input
                                        type="file"
                                        name="profile_avatar"
                                        accept=".png, .jpg, .jpeg"
                                        onChange={(e) => {
                                            setStoreObject({
                                                ...storeObject,
                                                logo: e.target.files[0],
                                            });
                                            setErrors({
                                                ...errors,
                                                logo: e.target.files[0]?.name
                                                    ? ""
                                                    : "Store Logo is Mandatory",
                                            });
                                        }}
                                    />
                                    <input type="hidden" name="profile_avatar_remove" />
                                </label>
                                <span
                                    className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                    data-action="cancel"
                                    data-toggle="tooltip"
                                    title="Cancel avatar"
                                >
                                    <i className="ki ki-bold-close icon-xs text-muted"></i>
                                </span>
                                <small className="text-danger">{errors?.image}</small>
                            </div>
                        </div>
                        <div className="brand-info">
                            <ContentTextArea
                                placeholder="Store Description"
                                name={"Store Description (optional)"}
                                value={storeObject?.locationRequest?.Description?.en}
                                onChange={(e) => {
                                    setStoreObject({
                                        ...storeObject,
                                        locationRequest: {
                                            ...storeObject.locationRequest,
                                            Description: {
                                                ...storeObject.locationRequest?.Description,
                                                en: e.target.value,
                                            },
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Col>

            {separator}
            {sectionHeading('Store Address')}

            {renderInput({
                name: 'Address Line 01',
                required: true,
                errors: errors?.storeAddressLine1,
                value: storeObject?.locationRequest?.storeAddressLine1?.en,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        locationRequest: {
                            ...storeObject.locationRequest,
                            storeAddressLine1: {
                                ...storeObject.locationRequest?.storeAddressLine1,
                                en: e.target.value,
                            },
                        },
                    });
                    setErrors({
                        ...errors,
                        storeAddressLine1: e.target.value
                            ? ""
                            : "Address Line 01 is Mandatory",
                    });
                }
            }, 6)}

            {renderInput({
                name: 'Address Line 02',
                value: storeObject?.locationRequest?.storeAddressLine2?.en,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        locationRequest: {
                            ...storeObject.locationRequest,
                            storeAddressLine2: {
                                ...storeObject.locationRequest?.storeAddressLine2,
                                en: e.target.value,
                            },
                        },
                    });
                }
            }, 6)}

            {renderInput({
                name: 'Pincode/ Zip',
                required: true,
                errors: errors?.storePasscode,
                value: storeObject?.locationRequest?.storePasscode,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        locationRequest: {
                            ...storeObject.locationRequest,
                            storePasscode: e.target.value,
                        },
                    });
                    setErrors({
                        ...errors,
                        storePasscode: e.target.value
                            ? e.target.value.match(/^\d{6}$/)
                                ? ""
                                : "Invalid Pincode"
                            : "Pincode/Zip is Mandatory",
                    });
                }
            }, 6)}

            <Col className="gutter-row" xs={24} lg={6}>
                <SelectOption
                    placeholder="Select State"
                    required={true}
                    error={errors?.state}
                    isClearable
                    options={
                        data?.map((obj) => {
                            const { en } = obj.name;
                            return {
                                label: en.toUpperCase(),
                                value: obj,
                            };
                        }) || []
                    }
                    value={
                        storeObject?.locationRequest?.state?.name?.en
                            ? {
                                label: storeObject?.locationRequest?.state?.name?.en?.toUpperCase(),
                                value: storeObject?.locationRequest?.state,
                            }
                            : ""
                    }
                    onChange={(val) => {
                        if (val) {
                            setStoreObject({
                                ...storeObject,
                                locationRequest: {
                                    ...storeObject?.locationRequest,
                                    state: {
                                        ...storeObject?.locationRequest?.state,
                                        name: {
                                            en: val.value.name.en,
                                            hn: val.value.name.hn,
                                            pb: val.value.name.pb,
                                        },
                                        key: val.value.id,
                                        id: val.value.id,
                                    },
                                    city: {
                                        name: {
                                            en: "",
                                            hn: "",
                                            pb: "",
                                        },
                                        key: "",
                                        id: "",
                                    },
                                },
                            });
                            setErrors({
                                ...errors,
                                state: val.value ? "" : " State is Mandatory",
                            });
                        } else {
                            setStoreObject({
                                ...storeObject,
                                locationRequest: {
                                    ...storeObject?.locationRequest,
                                    state: {
                                        name: {
                                            en: "",
                                            hn: "",
                                            pb: "",
                                        },
                                        key: "",
                                        id: "",
                                    },
                                    city: {
                                        name: {
                                            en: "",
                                            hn: "",
                                            pb: "",
                                        },
                                        key: "",
                                        id: "",
                                    },
                                },
                            });
                            setErrors({
                                ...errors,
                                state: "State is Mandatory",
                            });
                        }
                    }}
                />
            </Col>

            <Col className="gutter-row" xs={24} lg={6}>
                <SelectOption
                    placeholder="Select District"
                    required={true}
                    isClearable
                    error={errors?.city}
                    options={districtOptions}
                    value={
                        storeObject?.locationRequest?.city?.name?.en
                            ? {
                                label: storeObject?.locationRequest?.city?.name?.en?.toUpperCase(),
                                value: storeObject?.locationRequest?.city,
                            }
                            : ""
                    }
                    onChange={(val) => {
                        if (val) {
                            setStoreObject({
                                ...storeObject,
                                locationRequest: {
                                    ...storeObject.locationRequest,
                                    city: {
                                        ...storeObject.locationRequest.city,
                                        name: {
                                            en: val.value.name.en,
                                            hn: val.value.name.hn,
                                            pb: val.value.name.pb,
                                        },
                                        key: val.value.id,
                                        id: val.value.id,
                                    },
                                },
                            });
                            setErrors({
                                ...errors,
                                city: val.value ? "" : "District is Mandatory",
                            });
                        } else {
                            setStoreObject({
                                ...storeObject,
                                locationRequest: {
                                    ...storeObject.locationRequest,
                                    city: {
                                        name: {
                                            en: "",
                                            hn: "",
                                            pb: "",
                                        },
                                        key: "",
                                        id: "",
                                    },
                                },
                            });
                            setErrors({
                                ...errors,
                                city: "District is Mandatory",
                            });
                        }
                    }}

                />
            </Col>

            {renderInput({
                name: 'Landmark (optional)',
                value: storeObject?.locationRequest?.landMark?.en,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        locationRequest: {
                            ...storeObject.locationRequest,
                            landMark: {
                                ...storeObject.locationRequest?.landMark,
                                en: e.target.value,
                            },
                        },
                    });
                }
            }, 6)}

            {renderInput({
                name: 'Latitude',
                required: true,
                errors: errors?.latitude,
                value: storeObject?.longLatCoordinates?.latitude,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        longLatCoordinates: {
                            ...storeObject.longLatCoordinates,
                            latitude: e.target.value,
                        },
                    });
                    setErrors({
                        ...errors,
                        latitude: e.target.value ? "" : "Latitude is Mandatory",
                    });
                }
            }, 6)}

            {renderInput({
                name: 'Longitude',
                required: true,
                errors: errors?.longitude,
                value: storeObject?.longLatCoordinates?.longitude,
                onChange: (e) => {
                    setStoreObject({
                        ...storeObject,
                        longLatCoordinates: {
                            ...storeObject.longLatCoordinates,
                            longitude: e.target.value,
                        },
                    });
                    setErrors({
                        ...errors,
                        longitude: e.target.value ? "" : "Longitude is Mandatory",
                    });
                }
            }, 6)}
        </Row>
    );
};

export default GeneralSettings;